export const capitalEachLetter = (str) => {
  let newName =
    str &&
    str
      .split(" ")
      .map((ele) => ele[0]?.toUpperCase() + ele.slice(1))
      .join(" ");
  return newName;
};

export const formatTrayName = (name = "") => {
  if (!name) return "";

  // First, handle if the name contains spaces (e.g., "sahil mane")
  if (name.includes(" ")) {
    return name
      .split(" ")
      .map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" ");
  }

  // Handle hyphenated words (e.g., "gp-chain")
  const words = name.toLowerCase().split("-");

  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase() + words[0].slice(1);
  }

  return `${words[0].toUpperCase()}-${words[1].charAt(0).toUpperCase()}${words[1].slice(1)}`;
};
